import React from "react";
import "./PriceChangeDialog.css";

export default function PriceChangeDialog({ reprice, onAccept, onDismiss }) {
  if (!reprice) return null;
  return (
    <div className="fe2-reprice" role="dialog" aria-modal="true" aria-labelledby="fe2-reprice-title">
      <div className="fe2-reprice__panel">
        <h2 id="fe2-reprice-title" className="fe2-reprice__title">
          המחיר התעדכן
        </h2>
        <p className="fe2-reprice__msg">{reprice.message}</p>
        <div className="fe2-reprice__prices">
          <div>
            <span className="fe2-reprice__label">מחיר קודם</span>
            <strong className="fe2-reprice__old fe2-ltr">
              {reprice.previousPerPassengerLabel}
            </strong>
          </div>
          <div>
            <span className="fe2-reprice__label">מחיר חדש</span>
            <strong className="fe2-reprice__new fe2-ltr">
              {reprice.newPerPassengerLabel}
            </strong>
          </div>
        </div>
        <div className="fe2-reprice__totals fe2-ltr">
          {reprice.previousTotalLabel} → {reprice.newTotalLabel}
        </div>
        <div className="fe2-reprice__actions">
          <button type="button" className="fe2-reprice__accept" onClick={onAccept}>
            אישור מחיר חדש
          </button>
          <button type="button" className="fe2-reprice__dismiss" onClick={onDismiss}>
            חזרה לתוצאות
          </button>
        </div>
      </div>
    </div>
  );
}
